import styled from "@emotion/styled";
import { CloseButton } from "src/atoms/CloseButton";
import {
  HEADER_STICKY_OFFSET,
  PDP_BREADCRUMB_HEIGHT,
} from "src/utils/constants";

const StyledProductView = styled.div`
  margin-bottom: 80px;

  .ProductView__productPhotos {
    width: 100%;
    max-width: 520px;
    @media screen and (max-width: ${({ theme }) => theme.breakpoints[1]}) {
      max-width: 100%;
    }
  }

  .ProductView__productSidebar {
    position: sticky;
    top: ${HEADER_STICKY_OFFSET + PDP_BREADCRUMB_HEIGHT}px;
    display: grid;
    grid-template-columns: 1fr;
    row-gap: ${({ theme }) => theme.space.space24};
    width: 100%;
    height: fit-content;
    grid-row: 2;

    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
      top: 0;
      position: relative;
      grid-row: 3;
    }
  }

  .ProductView__productMeta,
  .ProductView__productOrder {
    margin-top: 0;
  }

  .ProductView__productsMore {
    margin-top: 80px;
  }

  .product-details {
    display: grid;
    grid-template-columns: 1fr minmax(0, 392px);
    column-gap: ${({ theme }) => theme.space.space32};

    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
      grid-template-columns: 1fr;
      row-gap: ${({ theme }) => theme.space.space16};
    }

    .product-breadcrumb-wrapper {
      grid-column: 1 / -1;
      position: sticky;
      top: ${HEADER_STICKY_OFFSET}px;
      display: flex;
      place-items: center;
      padding-block: ${({ theme }) => theme.space.space8};
      background-color: ${({ theme }) => theme.colors.tone.white};
      z-index: 10;

      @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        display: none;
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints[1]}) {
    .ProductView__productsMore {
      margin-top: 40px;
    }
  }
`;

const PhotosModalContainer = styled.div`
  position: relative;
  margin: 0;
  padding: 0;
  width: 100vw;
  max-width: 100%;
  height: 100%;
  position: relative;
  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    width: 448px;
  }
`;

const StyledCloseButton = styled(CloseButton)`
  background-color: ${({ theme }) => theme.colors.tone.white};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.colors.tone.silver};

  &:hover {
    opacity: 1;
  }
`;

const StyledCloseContainer = styled.div`
  background: transparent;
  left: 0;
  padding: 16px;
  position: absolute;
  right: 16px;
  top: 0;
  width: 100%;
  z-index: 2;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;

const StyledProductPhotoContainer = styled.div`
  display: flex;
  max-height: 624px;
  width: 520px;

  @media (max-width: ${({ theme }) => theme.breakpoints[1]}) {
    width: calc(100% + 40px);
    max-height: 370px;
  }

  @media (min-width: ${({ theme }) =>
      theme.breakpoints[1]}) and (max-width: ${({ theme }) =>
      theme.breakpoints[2]}) {
    width: calc(100% + 40px);
    max-width: 400px;
  }
`;

const StyledCarousels = styled.div`
  margin-top: ${({ theme }) => theme.space.space24};
`;

const CardsLoader = styled.div`
  margin-top: ${({ theme }) => theme.space.space32};
  padding-top: ${({ theme }) => theme.space.space32};
`;

export {
  StyledProductView,
  StyledCloseButton,
  PhotosModalContainer,
  StyledCloseContainer,
  StyledProductPhotoContainer,
  StyledCarousels,
  CardsLoader,
};
